import React, { createContext, useContext, useRef, useState, useEffect } from 'react';
interface IdleContextType {
  isIdle: boolean;
}
const IdleContext = createContext<IdleContextType>({ isIdle: false });
export const useIdleContext = () => useContext(IdleContext);

export const IdleTimerProvider: React.FC<{
  children: React.ReactNode;
  idleTime?: number;
  onIdle?: () => void;
  onActive?: () => void;
}> = ({ children, idleTime = 60000, onIdle, onActive }) => {
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isIdleRef = useRef(false);

  const markIdle = () => {
    setIsIdle(true);
    isIdleRef.current = true;
    onIdle?.();
  };

  const markActive = () => {
    if (isIdleRef.current) {
      setIsIdle(false);
      isIdleRef.current = false;
      onActive?.(); 
    }
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    markActive();
    timerRef.current = setTimeout(() => {
      markIdle();
    }, idleTime);
  };

  useEffect(() => {
    const activityEvents = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
    activityEvents.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer(); 
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [idleTime]);

  return (
    <IdleContext.Provider value={{ isIdle }}>
      {children}
    </IdleContext.Provider>
  );
};
